import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import PropTypes from 'prop-types';
import { Spinner } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../../common/controls/Controls.jsx';
import { FileSearchOutlined } from '@ant-design/icons';

const RolesTable = ({ roles, onDelete, onDetailClick }) => {
  const { t } = useTranslation();
  const nameTextFilterProps = useDataGridTextFilter('name');

  const columns = useMemo(
    () => [
      {
        title: t('Názov'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...nameTextFilterProps,
      },
    ],
    [nameTextFilterProps, t],
  );

  const customSettings = (role) => {
    return (
      <IconButton
        icon={<FileSearchOutlined />}
        tooltip={t('Zobraziť detail roly')}
        onClick={(e) => {
          e.stopPropagation();
          onDetailClick(role.id);
        }}
      />
    );
  };

  if (!roles) {
    return <Spinner />;
  }

  return (
    <DataGrid
      rowKey={(role) => role.id}
      columns={columns}
      dataSource={roles || []}
      permissionsBasic={'roles'}
      uniqueTableId={'roles-table'}
      customSettings={customSettings}
      onDelete={onDelete}
      onRowDetailClick={(role) => onDetailClick(role.id)}
    />
  );
};

RolesTable.propTypes = {
  roles: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
};

export default RolesTable;
